// components/FeedbackPage.js
import React from 'react';

import Feedbacks from '../features/Feedback/components/Feedbacks';
const FeedbackPage = () => {
  return <Feedbacks />;
};

export default FeedbackPage;
